import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, State } from './activity-registry.reducer';
import { ActivityRegisterState } from '@core/models/swagger/activityRegistry';

export const selectActivityRegistryState = createFeatureSelector<State>(featureKey);

export const getActivityRegisterData = createSelector(selectActivityRegistryState, (state: State) => state);
export const getProjectId = createSelector(
    selectActivityRegistryState,
    (state: ActivityRegisterState) => state.projectId,
);

export const getSessionId = createSelector(
    selectActivityRegistryState,
    (state: ActivityRegisterState) => state.sessionId,
);